import React from "react";
import { Link } from "react-router-dom";
import { useAssessmentStore } from "@/contexts/assessment/store";
import { IS_FOUNDER_CONFIGURED } from "@/pages/About";

/**
 * Sitewide header, deliberately dark.
 *
 * It used to be white with a blue wordmark, which put a hard seam directly
 * above the midnight hero on "/". Ink here means the header reads as one
 * surface with the hero, and as branded chrome above the light content pages.
 */
const navLink = "text-starlight/70 hover:text-gold transition-colors";

export const Header: React.FC = () => {
  return (
    <header className="bg-ink border-b border-white/10">
      <div className="container mx-auto px-6 py-5">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-12">
            {/* Logo/Brand */}
            <Link to="/" className="flex items-center cursor-pointer">
              <span className="font-display text-2xl uppercase tracking-wide text-starlight mr-4">
                Adi Astra
              </span>
            </Link>

            {/* Main Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/features" className={navLink}>
                How We Work
              </Link>
              <Link to="/solutions" className={navLink}>
                Solutions
              </Link>
              <Link to="/pricing" className={navLink}>
                Pricing
              </Link>
              <Link to="/guides" className={navLink}>
                Guides
              </Link>
              {IS_FOUNDER_CONFIGURED && (
                <Link to="/about" className={navLink}>
                  About
                </Link>
              )}
              <Link to="/contact" className={navLink}>
                Contact
              </Link>
            </nav>
          </div>

          {/* CTA Buttons */}
          <div className="flex items-center space-x-4">
            <Link to="/login" className={`hidden sm:inline ${navLink}`}>
              Log in
            </Link>
            <StartAssessmentButton />
          </div>
        </div>
      </div>
    </header>
  );
};

const StartAssessmentButton: React.FC = () => {
  const { resetAssessment } = useAssessmentStore((state) => state);

  return (
    <Link
      to="/assessment"
      onClick={() => resetAssessment()}
      className="bg-gold text-gold-foreground font-semibold px-4 py-2 rounded-lg hover:bg-gold/90 transition-colors"
    >
      Start Assessment
    </Link>
  );
};
